import { createWelopeClient, type WelopeClient } from "@welope/api-client";

// The landing page never authenticates — it only ever calls public
// procedures (currently just waitlist.join), so there's no token to send.
const apiUrl = import.meta.env.VITE_API_URL ?? "http://localhost:4000";

export const trpc: WelopeClient = createWelopeClient({
  apiUrl,
  getAccessToken: () => null,
});
